import { render } from "./WebSkillRanking.vue?vue&type=template&id=f560c50c"
import script from "./WebSkillRanking.vue?vue&type=script&lang=js"
export * from "./WebSkillRanking.vue?vue&type=script&lang=js"

import "./WebSkillRanking.vue?vue&type=style&index=0&id=f560c50c&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__